import axios from "axios";
import {
  getMessagesSuccess,
  getMessagesFail,
  getMessageByIdSuccess,
  getMessageByIdFail,
  getArchivedSuccess,
  getArchivedFail,
  getDeleteSuccess,
  getDeleteFail,
  resetData,
  updateMessageNoteSuccess,
  updateMessageNoteFail,
  searchMessagesSuccess,
  searchMessagesFail,
  moveToInboxSuccess,
  moveToInboxFail
} from "../constant";
import { Api } from "../../Config/config.js";
import { store } from "../store";


export const MessagesAction = async (dispatch, accountID, params) => {
  try {
    const response = await axios.get(`${Api}messages`, {
      params: {
        accountID: accountID,
        sortBy: "-createdAt",
        ...params,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });
    dispatch({
      type: getMessagesSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: getMessagesFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const MessageDetailsAction = async (dispatch, id, accountID) => {
  try {
    const response = await axios.get(`${Api}messages/${id}`, {
      params : {accountID : accountID},
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: getMessageByIdSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: getMessageByIdFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const MessageInboxAction = async (dispatch, id,accountID) => {
  try {
    const response = await axios.patch(`${Api}messages/${id}/inbox`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },accountID
    });
    dispatch({
      type: moveToInboxSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: moveToInboxFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const MessageArchiveAction = async (dispatch, id,accountID) => {
  try {
    const response = await axios.patch(`${Api}messages/${id}/archive`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
      },accountID
    });
    dispatch({
      type: getArchivedSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: getArchivedFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const MessageDeleteAction = async (dispatch, id,accountID) => {
  try {
    const response = await axios.delete(`${Api}messages/${id}/delete`, {
      params: {
        accountID: accountID,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      }
    });
    dispatch({
      type: getDeleteSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: getDeleteFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const UpdateMessageNotesAction = async (dispatch, id, notes) => {
  try {
    const response = await axios.patch(`${Api}messages/${id}/notes`, notes, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });
    dispatch({
      type: updateMessageNoteSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: updateMessageNoteFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const SearchMessage = async (
  dispatch,
  search,
  filters,
  accountID,
  signal
) => {
  try {
    const response = await axios.get(`${Api}messages/search?search=${search}`, {
      params: {
        accountID: accountID,
        isArchived: filters.isArchived,
        isDeleted: filters.isDeleted,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
      signal: signal,
    });

    dispatch({
      type: searchMessagesSuccess,
      payload: response.data,
    });
    return { success: true };
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      dispatch({
        type: searchMessagesFail,
        payload: error.response.data,
      });
    }
    return { success: false };
  }
};

export const ResetDataAction = async (dispatch) => {
  dispatch({
    type: resetData,
  });
};
